// LOCAL: stub replacement for apps/crew-merchant-ui/src/utils/observability.ts.
// Merchant-ui wires this into Sentry breadcrumbs; until Sentry is wired up here,
// we no-op so `api.ts` can keep the same call shape.
export type Breadcrumb = {
  category?: string;
  message?: string;
  level?: 'fatal' | 'error' | 'warning' | 'log' | 'info' | 'debug';
  data?: Record<string, unknown>;
};

export const addBreadcrumb: (breadcrumb: Breadcrumb) => void = () => {};
